import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const OptionsButtton = ({
  title,
  handleOpen,
  style,
  type,
  handleRequest,
  handleTransfer,
  hideButton,
  purchaseDisabled = false,
  requestDisabled = false,
  transferDisabled = false,
  purchaseMessage = "",
  requestMessage = "",
  transferMessage = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { t } = useTranslation();

  const handleListOpen = () => {
    setIsOpen(!isOpen);
  };

  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);
  
  // Hide entire button for ewallet if hideButton is true (time-based restriction)
  if (type === "ewallet" && hideButton) {
    return null;
  }
  
  // Handle click with restriction check
  const handleMainButtonClick = (e) => {
    if (purchaseDisabled) {
      e.preventDefault();
      toast.warning(purchaseMessage || t("kycRestrictionMessage"));
      return;
    }
    handleOpen();
  };
  
  const handleRequestClick = (e) => {
    if (requestDisabled) {
      e.preventDefault();
      toast.warning(requestMessage || t("kycRestrictionMessage"));
      setIsOpen(false);
      return;
    }
    handleRequest();
    setIsOpen(false);
  };
  
  const handleTransferClick = (e) => {
    if (transferDisabled) {
      e.preventDefault();
      toast.warning(transferMessage || t("kycRestrictionMessage"));
      setIsOpen(false);
      return;
    }
    handleTransfer();
    setIsOpen(false);
  };
  
  return (
    <>
      <div
        className="dropdown btn-group top_right_pop_btn_position"
        ref={dropdownRef}
      >
        {/* Main button - always visible, show message if restricted */}
        <Link
          className={`top_righ_pop_btn ${purchaseDisabled ? 'restricted' : ''}`}
          aria-controls="ewalletTrnsfer"
          onClick={handleMainButtonClick}
          style={purchaseDisabled ? { opacity: 0.7 } : {}}
        >
          {t(title)} {purchaseDisabled && <i className="fas fa-lock ms-1"></i>}
        </Link>
        
        {/* Dropdown toggle for epin */}
        {type === "epin" && (
          <span
            className={`dropdown-toggle btn drop_btn_sp ${isOpen ? "show" : ""}`}
            data-bs-toggle="dropdown"
            aria-expanded="false"
            onClick={handleListOpen}
          ></span>
        )}

        {/* Dropdown menu */}
        {type === "epin" && (
          <div
            className={`dropdown-menu usr_prfl ${isOpen ? "show" : ""}`}
            style={style}
          >
            <ul className="">
              <li>
                <Link 
                  className={`dropdown-item ${requestDisabled ? 'text-muted' : ''}`}
                  onClick={handleRequestClick}
                  style={requestDisabled ? { opacity: 0.7 } : {}}
                >
                  {t("epinRequest")} {requestDisabled && <i className="fas fa-lock ms-1"></i>}
                </Link>
              </li>
              <li>
                <Link 
                  className={`dropdown-item ${transferDisabled ? 'text-muted' : ''}`}
                  onClick={handleTransferClick}
                  style={transferDisabled ? { opacity: 0.7 } : {}}
                >
                  {t("epinTransfer")} {transferDisabled && <i className="fas fa-lock ms-1"></i>}
                </Link>
              </li>
            </ul>
          </div>
        )}
      </div>
    </>
  );
};

export default OptionsButtton;
